module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ReportHeader my-3"
  }, [_c('v-row', {
    staticClass: "headerCaption",
    attrs: {
      "align-start": "",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pa-0 py-2 text-center text-md-left fill-height overflow-hidden",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t("Header.performanceReport", [_vm.orgName])))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 py-2 text-center text-md-right no-wrap d-flex",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [((_vm.userRoles && _vm.userRoles.isAdmin) || _vm.allowedOrganizations.length > 0) ? _c('OrganizationFilter', {
    attrs: {
      "allowedOrgs": _vm.allowedOrganizations,
      "selectedOrganization": _vm.selectedOrganization,
      "solo": _vm.solo,
      "outline": _vm.outline
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "DateSelector ma-0 ml-3",
    attrs: {
      "items": _vm.optionsDates,
      "item-text": "label",
      "item-value": "id",
      "solo": "",
      "height": "40px",
      "append-icon": "",
      "single-line": "",
      "dense": "",
      "flat": "",
      "color": "black",
      "loading": _vm.loadingQuery && '#0098E1',
      "hide-details": ""
    },
    on: {
      "click": _vm.openDateSelector
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-icon', {
          attrs: {
            "color": "black"
          }
        }, [_vm._v("date_range")])]
      },
      proxy: true
    }, _vm._l((['item', 'selection']), function(slotName) {
      return {
        key: slotName,
        fn: function(data) {
          return [_c('div', {
            class: _vm.isCampaignReport(data.item) ? 'ReportDateItem CampaignReportDate' : 'ReportDateItem',
            attrs: {
              "slot": "item"
            },
            slot: "item"
          }, [(data.item.isPublished === false) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "warning"
            }
          }, [_vm._v("priority_high")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.label))])], 1)]
        }
      }
    })], null, true),
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.cardsData) ? _c('v-row', {
    staticClass: "headerCards mt-3 mb-8",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-0 pr-4 BlueGradient",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "rounded-sm py-4 px-2",
    attrs: {
      "dark": ""
    }
  }, [_c('h4', {
    staticClass: "text-center body-2 pb-3 text-truncate"
  }, [_vm._v(_vm._s(_vm.$t("Header.totalIrrigationHours")))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-center align-center my-2"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.cardsData.totalHours.toFixed(1).replace(/\.0+$/, '')))]), _vm._v(" "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v("hs")])])])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 pr-4",
    class: _vm.cardsData.pressureState ? 'GreenGradient' : 'RedGradient',
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "rounded-sm py-4 px-2",
    attrs: {
      "dark": ""
    }
  }, [_c('h4', {
    staticClass: "text-center body-2 pb-3 text-truncate"
  }, [_vm._v(_vm._s(_vm.$t("Header.workingPressure")))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-center align-center my-2"
  }, [(_vm.cardsData.pressureState) ? [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("check")]), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t("Header.correct")))])] : [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t("Header.incorrect")))])]], 2)])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    class: _vm.cardsData.totalFaults ? 'RedGradient' : 'GreenGradient',
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "rounded-sm py-4 px-2",
    attrs: {
      "dark": ""
    }
  }, [_c('h4', {
    staticClass: "text-center body-2 pb-3 text-truncate"
  }, [_vm._v(_vm._s(_vm.$t("Header.faultsInDevice")))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-center align-center my-2"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("warning")]), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.cardsData.totalFaults) + " " + _vm._s(_vm.$t("Header.faults")))])], 1)])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffadc484","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/Header.vue
// module id = 1757
// module chunks = 0